import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Container, Grid, Link as JoyLink, Divider } from '@mui/joy';

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                bgcolor: '#f5f5f5',
                py: 8,
                borderTop: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Container>
                <Grid container spacing={4}>
                    <Grid xs={12} sm={6} md={4}>
                        <Typography level="title-lg" sx={{ mb: 2, color: '#333' }}>
                            Мы на связи с 10:00 до 21:00!
                        </Typography>
                        <Typography level="body-sm" sx={{ mb: 1, color: '#333' }}>
                            Любые товары в кредит!
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <JoyLink
                                href="tel:+375173884387"
                                sx={{ 
                                    color: '#333', 
                                    textDecoration: 'none', 
                                    '&:hover': { 
                                        color: 'red',
                                        textDecoration: 'underline' 
                                    } 
                                }}
                            >
                                +375 (17) 388-43-87
                            </JoyLink>
                            <JoyLink
                                href="tel:+375333124450"
                                sx={{ 
                                    color: '#333', 
                                    textDecoration: 'none', 
                                    '&:hover': { 
                                        color: 'red',
                                        textDecoration: 'underline' 
                                    } 
                                }}
                            >
                                +375 (33) 312-44-50
                            </JoyLink>
                        </Box>
                    </Grid>

                    <Grid xs={12} sm={6} md={4}>
                        <Typography level="title-lg" sx={{ mb: 2, color: '#333' }}>
                            Полезные ссылки
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <JoyLink component={Link} to="/payment" sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: 'red' } }}>
                                Оплата
                            </JoyLink>
                            <JoyLink component={Link} to="/delivery" sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: 'red' } }}>
                                Доставка
                            </JoyLink>
                            <JoyLink component={Link} to="/installments" sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: 'red' } }}>
                                Оплата частями
                            </JoyLink>
                            <JoyLink component={Link} to="/privacy-policy" sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: 'red' } }}>
                                Политика конфиденциальности
                            </JoyLink>
                        </Box>
                    </Grid>

                    <Grid xs={12} sm={6} md={4}>
                        <Typography level="title-lg" sx={{ mb: 2, color: '#333' }}>
                            Информация
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <JoyLink component={Link} to="/public-offer" sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: 'red' } }}>
                                Публичная оферта
                            </JoyLink>
                            <JoyLink component={Link} to="/guarantee" sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: 'red' } }}>
                                Гарантия
                            </JoyLink>
                            <JoyLink component={Link} to="/return" sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: 'red' } }}>
                                Возврат и замена товара
                            </JoyLink>
                            <JoyLink component={Link} to="/about" sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: 'red' } }}>
                                О компании
                            </JoyLink>
                            <JoyLink component={Link} to="/contacts" sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: 'red' } }}>
                                Контакты
                            </JoyLink>
                        </Box>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

                <Typography
                    level="body-xs"
                    sx={{
                        color: 'rgba(0, 0, 0, 0.7)',
                        textAlign: 'center',
                        lineHeight: 1.8
                    }}
                >
                    ООО "БАУВЕРК"<br/>
                    УНП 193696124<br/>
                    Республика Беларусь, 220020, г. Минск, ул. Тимирязева, д. 97, каб. 22-24<br/>
                    Расчетный счет:  BY76ALFA30122D61350020270000  в ЗАО "Альфа-Банк", код банка ALFABY2X<br/>
                    </Typography>
            </Container>
        </Box>
    );
};

export default Footer;
